import React from "react";
import Ranking from "./Ranking/Ranking";

const RankingPage = () => {
  return <Ranking />;
};

export default RankingPage;
